export const regionsBarStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  height: 500,
};

export const scrollBarStyles = {
  display: 'flex',
  flexWrap: 'wrap',
};



// WEBPACK FOOTER //
// ./src/apps/receptions/assets/styles.js